<template>
  <div class="loading-container" :style="{ height }">
    <div class="loader-wrapper">
      <!-- Option 1: Animated Logo with Pulse Effect -->
      <div class="logo-loader">
        <img src="@/assets/buzzztv_logo.png" alt="BuzzzTech" class="logo-image"/>
        <div class="pulse-ring"></div>
        <div class="pulse-ring delayed"></div>
      </div>
      
      <!-- Loading dots animation -->
      <div class="loading-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: { type: String, default: '50vh' },
  }
};
</script>

<style lang="scss" scoped>
@use "@/styles/mixins" as *;

.loading-container {
  @include flex-center;
  background: transparent;
  position: relative;
}

.loader-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

// Logo Loader Styles
.logo-loader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .logo-image {
    width: 80px;
    height: 80px;
    object-fit: contain;
    filter: drop-shadow(0 4px 20px rgba(0,0,0,0.3));
    z-index: 2;
    position: relative;
  }
  
  .pulse-ring {
    position: absolute;
    border: 2px solid;
    border-color: black red green blue; /* top right bottom left */
    border-radius: 50%;
    width: 100px;
    height: 100px;
    animation: pulse 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
    
    &.delayed {
      animation-delay: 0.5s;
    }
  }
}

.loading-text {
  font-family: 'Arial', sans-serif;
  font-size: 1.8rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  display: flex;
  align-items: baseline;
  
  .brand-name {
    display: inline-flex;
    
    // Individual letter styling to match your logo
    &::before {
      content: 'B';
      color: #2c3e50;
      margin-right: 1px;
    }
    &::after {
      content: 'U';
      color: #e74c3c;
      margin-right: 1px;
    }
    // Hide the original text
    color: transparent;
    position: relative;
    
    // Add the remaining letters
    &:before {
      content: 'BU';
      position: absolute;
      left: 0;
      background: linear-gradient(to right, #2c3e50 0%, #2c3e50 50%, #e74c3c 50%, #e74c3c 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  
  // Updated BUZZ styling to match logo colors
  .buzz-letters {
    display: inline-flex;
    font-weight: 900;
    
    .letter-b1 {
      color: #2c3e50; // Dark blue/black
    }
    .letter-u {
      color: #2c3e50;
    }
    .letter-z1 {
      color: #e74c3c; // Red
    }

    .letter-z2 {
      color: #27ae60; // Green
    }

    .letter-z3 {
      color: #3498db; // Blue
    }

  }
  
  .brand-accent {
    color: #34495e;
    font-weight: 400;
    font-style: italic;
    margin-left: 2px;
    position: relative;
    
    // Add the curved underline like in your logo
    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 100%;
      height: 2px;
      background: linear-gradient(to right, #3498db, #2ecc71);
      border-radius: 2px;
      animation: underlineGlow 2s ease-in-out infinite alternate;
    }
  }
}

// Loading Dots
.loading-dots {
  display: flex;
  gap: 0.5rem;
  
  .dot {
    width: 8px;
    height: 8px;
    background: #667eea;
    border-radius: 50%;
    animation: dotBounce 1.4s ease-in-out infinite both;
    
    &:nth-child(1) { animation-delay: -0.32s; background: #ff6b6b; }
    &:nth-child(2) { animation-delay: -0.16s; background: #4ecdc4; }
    &:nth-child(3) { animation-delay: 0s; background: #667eea; }
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}

@keyframes underlineGlow {
  from {
    opacity: 0.7;
    transform: scaleX(0.8);
  }
  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

@keyframes dotBounce {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

// Responsive Design
@media (max-width: 768px) {
  .logo-loader .logo-image {
    width: 60px;
    height: 60px;
  }
  
  .pulse-ring {
    width: 90px !important;
    height: 90px !important;
  }
  
  .loading-text {
    font-size: 1.2rem;
  }
}
</style>